// The site's one public address. Every canonical tag, sitemap entry, schema URL and share link
// is built from this, so the whole site switches domain by changing NEXT_PUBLIC_SITE_URL
// (set it in the hosting dashboard for production) — never hard-code a domain anywhere else.
export const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || 'https://thewillowinteriors.com').replace(/\/+$/, '');
